import { render, staticRenderFns } from "./PermitApplicationReview.vue?vue&type=template&id=3a845100&"
import script from "./PermitApplicationReview.vue?vue&type=script&lang=js&"
export * from "./PermitApplicationReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports